import _toConsumableArray from '@babel/runtime-corejs3/helpers/toConsumableArray';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import { useRef, useCallback, useLayoutEffect, useEffect } from 'react';

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? useLayoutEffect : useEffect;
/**
 * https://reactjs.org/docs/hooks-faq.html#how-to-read-an-often-changing-value-from-usecallback
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any

function useEventCallback(fn) {
  var _context;

  var dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var ref = useRef(function () {
    throw new Error('Cannot call an event handler while rendering.');
  });
  useIsomorphicLayoutEffect(function () {
    ref.current = fn;
  }, _concatInstanceProperty(_context = [fn]).call(_context, _toConsumableArray(dependencies)));
  var f = useCallback(function () {
    var fn = ref.current;
    return fn.apply(void 0, arguments);
  }, []);
  return f;
}

export { useEventCallback };
